<template>
	<div style="width: 90%;">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品id" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsId" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.isDiscounts" placeholder="请选择">
							<el-option key="0" label="未生效" :value="0">未生效</el-option>
							<el-option key="1" label="生效中" :value="1">生效中</el-option>
							<el-option key="2" label="已失效" :value="2">已失效</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.authStatus" placeholder="请选择">
							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="已通过" :value="1">已通过</el-option>
							<el-option key="2" label="已驳回" :value="2">已驳回</el-option>
						</el-select>
					</el-form-item>
					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
						<!-- <el-button type="primary" @click="dialogVisibleFun()">新增商品</el-button> -->
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						<!-- <el-button type="primary" @click="dialogChuxiao()">申请促销</el-button> -->
					</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="promtion.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		
			<el-table-column prop="goodsId" label="商品ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="supplierName" label="供应商名称" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="isDh" label="商品类别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDh==1">兑换产品</p>
					<p v-if="scope.row.isDh==0">首页产品</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="isDiscounts" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDiscounts==0">未生效</p>
					<p v-if="scope.row.isDiscounts==1">生效中</p>
					<p v-if="scope.row.isDiscounts==2">已失效</p>
				</template>
			</el-table-column>
			<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.authStatus==0">未审核</p>
					<p v-if="scope.row.authStatus==1">已审核</p>
					<p v-if="scope.row.authStatus==2">不通过</p>
				</template>
			</el-table-column>
			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="price" label="价格/元" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="costPrice" label="成本价" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="discountPrice" label="折扣价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="marketPrice" label="市场价/元" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="discountStartDatetime" label="开始时间" sortable align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="discountEndDatetime" label="结束时间" sortable align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					　<el-button v-if="scope.row.authStatus==0" size="small" type="text"
						@click="promShenhe(scope.row.id)">审核</el-button>
					<el-button v-else size="small" type="text" @click="seeDetail(scope.row.id)">查看详情</el-button>
				</template>　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="promtion.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="promtion.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		<el-dialog style="float:rigin" title="申请促销详情" :closeOnClickModal="false" :visible.sync="dialogDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="申请商品">
						<el-input type="text" disabled style="width: 70%;margin-right: 20px;" clearable
							v-model="Datails.goodsName" placeholder="请去选择商品" />
						<!-- <el-button type="primary" @click="gotoXz">去选择</el-button> -->
					</el-form-item>
					<div>
						<el-form-item label="零售价格(￥)" class="redItem">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="Datails.price" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣比例" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								 v-model="Datails.discountRate" placeholder="请输入折扣比例" />
						</el-form-item>
						<el-form-item label="折扣价格" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								v-model="Datails.discountPrice" placeholder="请输入折扣价格" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣份数" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="Datails.stock" placeholder="请输入份数" />
						</el-form-item>
						<el-form-item label="限购份数" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="Datails.quantityLimit" placeholder="请输入份数 (0默认不限购)" />
							<!-- <span>(0默认不限购)</span> -->
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开始日期"  class="redItem" style="width: 50%;">
							<el-date-picker v-model="Datails.discountStartDatetime" disabled
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束日期" class="redItem" style="width: 50%;">
							<el-date-picker v-model="Datails.discountEndDatetime" disabled
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="申请说明" class="redItem">
							<el-input type="textarea" disabled size="small" width="100" :autosize="{ minRows: 3, maxRows: 6}"
								v-model="Datails.remark" placeholder="请输入申请说明" />
						</el-form-item>
					</div>
				</el-form>
				
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogDatil = false">取 消</el-button>
				<el-button  type="primary" @click="bohui">驳 回</el-button>
				<el-button type="primary" @click="confirm">通 过</el-button>
			</div>
		</el-dialog>
		<el-dialog style="float:rigin" title="审核驳回" :visible.sync="dialogRejection" width="35%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form2" :rules="mainFormRules" size="medium">
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form2.refuseReason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
					<el-form-item style="text-align: center;">
						<el-button :loading="loading" type="primary" @click="editCloudCheck()">提交
						</el-button>
						<el-button @click="dialogRejection=false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" title="详情" :closeOnClickModal="false" :visible.sync="dlogeDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="申请商品">
						<el-input type="text" disabled style="width: 70%;margin-right: 20px;" clearable
							v-model="Datails.goodsName" placeholder="请去选择商品" />
						<!-- <el-button type="primary" @click="gotoXz">去选择</el-button> -->
					</el-form-item>
					<div>
						<el-form-item label="零售价格(￥)" class="redItem">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="Datails.price" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣比例" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								 v-model="Datails.discountRate" placeholder="请输入折扣比例" />
						</el-form-item>
						<el-form-item label="折扣价格" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-1.]/g,’’)" size="small" width="50"
								v-model="Datails.discountPrice" placeholder="请输入折扣价格" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="折扣份数" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="Datails.stock" placeholder="请输入份数" />
						</el-form-item>
						<el-form-item label="限购份数" class="redItem" style="width: 50%;">
							<el-input type="number" disabled oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="Datails.quantityLimit" placeholder="请输入份数 (0默认不限购)" />
							<!-- <span>(0默认不限购)</span> -->
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开始日期"  class="redItem" style="width: 50%;">
							<el-date-picker v-model="Datails.discountStartDatetime" disabled
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束日期" class="redItem" style="width: 50%;">
							<el-date-picker v-model="Datails.discountEndDatetime" disabled
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="申请说明" class="redItem">
							<el-input type="textarea" disabled size="small" width="100" :autosize="{ minRows: 3, maxRows: 6}"
								v-model="Datails.remark" placeholder="请输入申请说明" />
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dlogeDatil = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loading: false,
				searchInfo: {},
				promtion: {},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				selectStoreName:[], //选择店铺的店铺列表
				accountList: [],
				storeNameId:'', //店铺iD
				supplierId:'', // 供应商id 
				dialogDatil:false, //审核弹窗
				Datails:{},
				dialogRejection:false, //审核驳回弹窗
				dlogeDatil:false, //查看详情弹窗
				form2:{
					refuseReason:''
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
					remak:{
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					}
				},
				pomId:''
			}
		},
		
		methods:{
			// 导出
			downloadFile(){
				
			},
			// 查询
			search(){
				this.page.pageNum=1
				this.getPromoGoodslist()
			},
			// 清空
			empty(){
				this.searchInfo = {}
			},
			
			// 审核
			promShenhe(id){
				this.pomId = id
				this.dialogDatil = true
				this.$api.seeDatil(this.pomId).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.Datails = res.data
					}
				})
			},
			// 通过
			confirm(){
				let data = {
					id:this.pomId,
					// refuseReason:this.form2.refuseReason,
					authStatus:1
				}
				this.$api.promoBohui(this.$encrypt(data)).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogDatil = false
						this.getPromoGoodslist()
					}else{
						this.$message({
							message: res.message,
							type: 'waring'
						});
					}
				})
			},
			//审核驳回
			bohui(){
				this.dialogRejection = true
				
			},
			editCloudCheck(){
				
				let data = {
					id:this.pomId,
					refuseReason:this.form2.refuseReason,
					authStatus:2
				}
				this.$api.promoBohui(this.$encrypt(data)).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogRejection = false
						this.dialogDatil = false
						this.getPromoGoodslist()
					}
				})
			},
			// 选择店铺
			getStoreName(e){
				console.log(e);
				this.storeNameId = e
				console.log(this.selectStoreName);
				console.log(this.storeName);
				let obj = {};
				obj = this.selectStoreName.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				console.log(obj);
				this.searchInfo.storeName = obj.storeName
				this.accountList = []
				if(e){
					this.$api.supplierNameList(this.$encrypt({storeId:e})).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						if(res.state == 'success'){
							this.accountList = res.data
						}
					})
				}
			},
			// 选择供应商
			getStoreAndUser(e){
				console.log(e);
				this.supplierId = e
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				console.log(obj);
				this.searchInfo.supplierName = obj.supplierName
			},
			selectStore(){
				this.$api.selectStoreList().then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
		
					if(res.state == 'success'){
						
						this.selectStoreName = res.data
					}else {
						this.$message.error(res.message);
					}
				})
			},
			// 审核
			cloudShenhe(){
				
			},
			// 查看详情
			seeDetail(id){
				this.dlogeDatil = true
				this.$api.seeDatil(id).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.Datails = res.data
					}
				})
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getPromoGoodslist()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getPromoGoodslist()
			},
			// 商品列表
			getPromoGoodslist() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				}
				this.$api.promoExamile(this.$encrypt(data)).then(res => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.promtion = res.data
						this.loading = false
					}
				})
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
		},
		created(){
			this.selectStore()
			this.getPromoGoodslist()
		}
	}
</script>

<style scoped lang="less">
	/deep/.el-input__inner{
		color: black !important;
	}
	/deep/.el-textarea__inner{
		color: black !important;
	}
</style>